// Project (Phase 4) helpers
export const PROJECT_STATUSES = ["Confirmed", "Shoot done", "Delivered", "Completed", "Cancelled"];

export const PROJECT_STATUS_COLORS = {
  Confirmed: "var(--brand-primary)",
  "Shoot done": "#7c6492",
  Delivered: "var(--brand-champagne)",
  Completed: "var(--brand-success)",
  Cancelled: "var(--brand-danger)",
};

export const PAYOUT_MODES = ["UPI", "Bank transfer", "Cash", "Card", "Other"];

export const VENDOR_TYPE_LABELS = {
  individual: "Individual",
  agency: "Agency",
};

export function daysToGo(weddingDate) {
  if (!weddingDate) return null;
  const d = new Date(weddingDate);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / (1000 * 60 * 60 * 24));
}

export function shortDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

export function eventTime(start, end) {
  if (!start && !end) return "";
  return [start, end].filter(Boolean).join("–");
}
